import GoogleDriveCard from './GoogleDriveCard';

import { AppConfigType } from '../../AppList/AppList';

export const GOOGLE_DRIVE: AppConfigType = {
  id: 'google',
  name: 'Google Drive',
  shortName: 'Google Drive',
  css: {
    image: 'url(/images/gdrive-icon.png',
  },
  Card: GoogleDriveCard,
};
